import SetSquareIcon from "@/components/icons/set_square";
import PowerIcon from "@/components/icons/power";
import OffsetsIcon from "@/components/icons/offsets";
import PresentIcon from "@/components/icons/present";

export type Section = "measure" | "reduce" | "remove" | "report";

const sections: Record<
  Section,
  {
    title: string;
    colorPrimary: string;
    icon: () => JSX.Element;
  }
> = {
  measure: {
    title: "Measure",
    colorPrimary: "#0AA9E4",
    icon: SetSquareIcon,
  },
  reduce: {
    title: "Reduce",
    colorPrimary: "#48AF54",
    icon: PowerIcon,
  },
  remove: {
    title: "Remove",
    colorPrimary: "#FAC31D",
    icon: OffsetsIcon,
  },
  report: {
    title: "Report",
    colorPrimary: "#FF8D73",
    icon: PresentIcon,
  },
};

export default sections;
